import { render, staticRenderFns } from "./GenericHistorical.vue?vue&type=template&id=0babce2e&scoped=true"
import script from "./GenericHistorical.vue?vue&type=script&lang=js"
export * from "./GenericHistorical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0babce2e",
  null
  
)

export default component.exports